import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

import Chat from '@/components/blocks/Thread/Chat';
import { firstRunSummaryStore } from '@/features/context-collection';
import { SearchFocusSchema } from '@/lib/search-focus';

const ChatRoute = observer(() => {
  const { chatId } = Route.useParams();

  return <Chat key={chatId} />;
});

export const Route = createFileRoute('/_authenticated/chats/$chatId')({
  component: ChatRoute,
  validateSearch: SearchFocusSchema.passthrough().parse,
  onEnter({ params: { chatId } }) {
    if (
      firstRunSummaryStore.phase === 'ready' &&
      firstRunSummaryStore.chatId === chatId
    ) {
      firstRunSummaryStore.markDone();
    }
  },
});
